"use client";

import React from "react";
import { ShoppingBag } from "lucide-react";
import { useFastRouter } from "@/packages/hooks/useFastRouter";
import LABELS from "@/components/global-constant/src/general";

interface EmptyCartViewProps {
  onClose?: () => void;
  title?: string;
  message?: string;
  buttonText?: string;
}

export default function EmptyCartView({
  onClose,
  title = LABELS.CART?.EMPTY_TITLE || "Your Cart is Empty",
  message = LABELS.CART?.EMPTY_MESSAGE || "Looks like you haven't added any items to your cart yet.",
  buttonText = LABELS.CART?.CONTINUE_SHOPPING || "Continue Shopping",
}: EmptyCartViewProps) {

  const { fastPush } = useFastRouter();

  const handleContinueShopping = () => {
    if (onClose) {
      onClose();
    }
    fastPush("/");
  };

  return (
    <div className="flex-1 flex flex-col justify-center items-center text-center p-6 space-y-4">
      <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center text-slate-400 mb-2">
        <ShoppingBag className="w-8 h-8 opacity-50 text-slate-500" />
      </div>
      <h3 className="text-base font-bold text-slate-800">{title}</h3>
      <p className="text-xs text-slate-500 max-w-[220px]">{message}</p>
      <button
        type="button"
        onClick={handleContinueShopping}
        className="mt-2 bg-[var(--brand-accent)] hover:bg-[var(--brand-accent-hover)] text-white text-xs font-bold px-6 py-2.5 rounded-full shadow-md transition-colors cursor-pointer"
      >
        {buttonText}
      </button>
    </div>
  );
}
